import React from "react";

const Paginator = ({ page, pageSize, total, onPageChange, onPageSizeChange }) => {
  if (!total) return null;
  const totalPages = Math.ceil(total / pageSize);
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  const pages = new Set([1, totalPages]);
  for (let i = Math.max(1, page - 2); i <= Math.min(totalPages, page + 2); i++) {
    pages.add(i);
  }
  const pageNums = [...pages].sort((a, b) => a - b);

  return (
    <div className="paginator">
      <select
        className="paginator-size"
        value={pageSize}
        onChange={e => { onPageChange(1); onPageSizeChange(Number(e.target.value)); }}
        aria-label="Rows per page"
      >
        {[10, 25, 50, 100].map(s => (
          <option key={s} value={s}>{s} / page</option>
        ))}
      </select>
      <span className="paginator-info">{start}–{end} of {total}</span>
      {totalPages > 1 && (
        <>
          <button
            className="paginator-btn"
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
            aria-label="Previous page"
          >
            ‹
          </button>
          {pageNums.map((p, i) => {
            const prev = pageNums[i - 1];
            return (
              <React.Fragment key={p}>
                {prev && p - prev > 1 && <span className="paginator-ellipsis">…</span>}
                <button
                  className={`paginator-btn${p === page ? " active" : ""}`}
                  onClick={() => onPageChange(p)}
                  aria-current={p === page ? "page" : undefined}
                >
                  {p}
                </button>
              </React.Fragment>
            );
          })}
          <button
            className="paginator-btn"
            disabled={page === totalPages}
            onClick={() => onPageChange(page + 1)}
            aria-label="Next page"
          >
            ›
          </button>
        </>
      )}
    </div>
  );
};

export default Paginator;
